<template>
<!-- 卡申请记录 -->
  <div class="content">
    <el-form :model="queryParams" ref="queryForm"  :inline="true" label-width="68px">
      <el-form-item  prop="iccid">
        <el-input v-model="queryParams.iccid" placeholder="ICCID" @keyup.enter.native="search" clearable></el-input>
      </el-form-item>
      <el-form-item  prop="orderNum">
        <el-input v-model="queryParams.orderNum" placeholder="订单号" @keyup.enter.native="search" clearable></el-input>
      </el-form-item>
      <el-form-item  prop="contactMan">
        <el-input v-model="queryParams.contactMan" filterable placeholder="联系人" @keyup.enter.native="search" clearable></el-input>
      </el-form-item>
      <el-form-item  prop="contactPhone">
        <el-input v-model="queryParams.contactPhone" filterable placeholder="电话" @keyup.enter.native="search" clearable></el-input>
      </el-form-item>
      <el-form-item  prop="contactAddr">
        <el-input v-model="queryParams.contactAddr" filterable placeholder="地址" @keyup.enter.native="search" clearable></el-input>
      </el-form-item>
      <el-form-item  prop="dateRange">
        <el-date-picker
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                v-model="dateRange"
                @change="search"
                type="daterange"
                range-separator="-"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button type="primary" icon="el-icon-refresh" @click="resetQuery">重置</el-button>
      </el-form-item>
    </el-form>
    <!--搜索-->
    <!--列表-->
    <el-table :data="tableData" ref="tableData" border v-loading="loading" @sort-change="tableSortChange">
      <el-table-column prop="ids" label="序号" align="center" width="60px"></el-table-column>
      <!-- <el-table-column prop="iccid" label="ICCID" min-width="100" align="center" :show-overflow-tooltip="true"></el-table-column> -->
      <el-table-column prop="orderNum" label="订单号" align="center" min-width="180" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="contactMan" label="联系人" align="center" min-width="120" :show-overflow-tooltip="true">
        <template slot-scope="{row}">
          <span v-if="row.type == '2'">{{row.email || '-'}}</span>
          <span v-else>{{row.contactMan || '-'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="contactPhone" label="电话" align="center" min-width="100" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="contactAddr" label="地址" align="center" min-width="160" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="type" label="类型" align="center" min-width="80">
          <template slot-scope="{row}">
              <el-tag v-if="row.type == '1'">SIM</el-tag>
              <el-tag type="success" v-else-if="row.type == '2'">ESIM</el-tag>
              <el-tag type="info" v-else>未知 </el-tag>
          </template>
      </el-table-column>
      <el-table-column prop="status" label="状态" align="center" min-width="80">
          <template slot-scope="{row}">
            <template v-if="row.type == '2'">
              <el-tag v-if="row.status == '0'">发送失败</el-tag>
              <el-tag type="warning" v-if="row.status == '1'">发送中</el-tag>
              <el-tag type="success" v-if="row.status == '2'">已发送</el-tag>
            </template>
            <template v-else>
              <el-tag v-if="row.status == '0'">初始化</el-tag>
              <el-tag type="warning" v-if="row.status == '1'">待发货</el-tag>
              <el-tag type="success" v-if="row.status == '2'">已发货</el-tag>
            </template>
          </template>
      </el-table-column>
      <el-table-column prop="logisticCompany" label="物流公司" align="center" min-width="80" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="logisticNo" label="物流单号" align="center" min-width="100" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="cardNum" label="总卡数/成功数" align="center" min-width="100" :show-overflow-tooltip="true">
        <template slot-scope="{row}">
          {{row.cardNum || '0'}}/{{row.actualNum || '0'}}

        </template>
      </el-table-column>
      <el-table-column prop="rmk" label="备注" align="center" min-width="140" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="createTime" label="创建时间" align="center" min-width="120">
        <template slot-scope="scope">
          <span>{{ parseTime(scope.row.createTime,'{y}-{m}-{d} {h}:{i}') }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="updateTime" label="更新时间" align="center" min-width="120">
        <template slot-scope="scope">
          <span>{{ parseTime(scope.row.updateTime,'{y}-{m}-{d} {h}:{i}') }}</span>
        </template>
      </el-table-column>
      <!--操作-->
      <el-table-column label="操作" min-width="80" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" icon="el-icon-view" @click="openFeedback(scope.row)">详情</el-button>
          <el-button v-if="scope.row.type == '1'" type="text" icon="el-icon-truck" @click="openFeedback(scope.row)">物流</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页-->
    <pagination
            v-show="total>0"
            :total="total"
            :page.sync="page"
            :limit.sync="pageSize"
            @pagination="initData"
    />
    <!--反馈物流-->
    <el-dialog title="物流信息" :visible.sync="dialogFormVisible" width="30%">
      <el-form :model="logisticsForm">
        <el-form-item label="物流公司" :label-width="formLabelWidth">
          <el-input v-model="logisticsForm.logisticCompany" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="物流单号" :label-width="formLabelWidth">
          <el-input v-model="logisticsForm.logisticNo" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="feedbackLogistic()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { internationalApplicationList,submitSimLogistic } from "@/api/international.js";

  export default {
    name: 'simLogisticRecord',
    data () {
      return {
        loading: false,
        dateRange: [],
        logisticsForm: {
          id: null,
          logisticCompany: null,
          logisticNo: null,
          status: '2'
        },
        formLabelWidth: '120px',
        dialogFormVisible: false,
        queryParams: {
          iccid: undefined,
          orderNum: undefined,
          contactMan: undefined,
          contactPhone: undefined,
          contactAddr: undefined
        },
        tableData: [{
          id: undefined,
          iccid: undefined,
          orderNum: undefined,
          logisticNo: undefined,
          logisticCompany: undefined,
          contactMan: undefined,
          contactPhone: undefined,
          contactAddr: undefined,
          createTime: undefined,
          status: undefined,
          rmk: undefined
        }],
        searchTime: [],
        page: 1,
        pageSize: 20,
        total: 0,
        agentOptions: [],
        // 排序方式
        sortOrder: "",
        // 排序名称
        sortName: "",
      }
    },
    computed: {
      adminShow () {
        return this.$store.getters.user.userType == "1";
      }
    },
    methods: {
      // 搜索
      search () {
        this.tableData = [];
        this.page = 1;
        this.initData();
      },
      // 重置
      resetQuery () {
        this.dateRange = [];
        this.resetForm("queryForm");
        this.search();
      },
      // 排序
      tableSortChange (val) {
        this.sortOrder = val.order == "descending" ? "desc" : "asc";
        this.sortName = val.prop == "createTime" ? "createTime" : "updateTime";
        this.initData();
      },
      // 获取列表的数据
      initData () {
        let params = {
          model: {
            ... this.addDateRange(this.queryParams, this.dateRange),
            order: this.sortOrder,
            sort: this.sortName,
          },
          page: this.page,
          pageSize: this.pageSize,
        };
        this.loading = true;
        this.tableData = [];
        internationalApplicationList(params).then(res => {
          this.loading = false;
          this.tableData = res.data.data.records;
          this.tableData.map((item, index) => {
            item.ids = index + 1
          })
          this.total = res.data.data.total;
        })
      },
      //反馈物流
      openFeedback(row) {
        this.dialogFormVisible = true;
        this.logisticsForm.id = row.id;
      },
      feedbackLogistic() {
        if (!this.logisticsForm.logisticCompany || !this.logisticsForm.logisticNo) {
          this.$message.error("物流公司和单号不能为空");
          return
        }
        submitSimLogistic(this.logisticsForm).then((res) => {
          if (res.data.code == 200) {
            this.$notify({
              title: "成功",
              message: "反馈物流成功",
              type: "success",
              duration: 1500,
            });
            this.dialogFormVisible = false;
            this.logisticsForm = {id: null, logisticCompany: null, logisticNo: null, status: '2'};
            this.initData();
          } else {
            this.$message.error(res.data.message);
          }
        });
      },
    },
    mounted () {
      this.initData();
    },
    created () {},
    watch: {
        '$route': {
            handler: function (to, from) {
                if (to.name == "simLogisticRecord") {
                    this.initData();
                }
            },
            // 深度观察监听
            deep: true,
        },
    },
  };
</script>
<style scoped lang="less">
.table-expand{
  margin-left: 10px;
  .el-form-item {
    margin-bottom: 0px;
  }
}

</style>
